export const Analytics = {
  subjectId: {
    expandAllSectionsClicked: 'privacyAndSecurityExpandAllSectionsClicked',
    collapseAllSectionsClicked: 'privacyAndSecurityCollapseAllSectionsClicked',
    readMoreClicked: 'privacyAndSecurityReadMoreClicked',
    readLessClicked: 'privacyAndSecurityReadLessClicked',
    expandSectionClicked: 'privacyAndSecurityExpandSectionClicked',
    feedbackCollectorYesClicked: 'privacyAndSecurityFeedbackCollectorYesClicked',
    feedbackCollectorNoClicked: 'privacyAndSecurityFeedbackCollectorNoClicked',
    feedbackCollectorSubmitClicked: 'privacySecurityFeedbackCollectorSubmitButtonClicked',
    feedbackCollectorPopupClosed: 'privacySecurityFeedbackCollectorPopupClosed',
    contactThePartnerClicked: 'privacyAndSecurityContactThePartnerClicked',
    questionnaireUiLinkClicked: 'privacyAndSecurityQuestionnaireUiLinkClicked',
    questionnaireUiEmailClicked: 'privacyAndSecurityQuestionnaireUiEmailClicked',
    viewDetailsClicked: 'privacyAndSecurityViewDetailsClicked',
    aboutProgramClicked: 'aboutTrustProgramClicked'
  }
};